export default __webpack_public_path__ + "static/media/breadcrumb.4cea6755.png";